import {
    FETCH_ACCESSORIES_DEMAND_FAILURE,
    FETCH_ACCESSORIES_DEMAND_REQUEST,
    FETCH_ACCESSORIES_DEMAND_SUCCESS,
    FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_FAILURE,
    FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_REQUEST,
    FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_SUCCESS,
    FETCH_SALES_ORDER_DEMAND_FABRIC_FAILURE,
    FETCH_SALES_ORDER_DEMAND_FABRIC_REQUEST,
    FETCH_SALES_ORDER_DEMAND_FABRIC_SUCCESS,
    FETCH_SALES_ORDER_DEMAND_FAILURE,
    FETCH_SALES_ORDER_DEMAND_REQUEST,
    FETCH_SALES_ORDER_DEMAND_SUCCESS,
    FETCH_DEMAND_INVOICE_REQUEST,
    FETCH_DEMAND_INVOICE_SUCCESS,
    FETCH_DEMAND_INVOICE_FAILURE,
    RESET_DEMAND_INVOICE,
    FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_REQUEST,
    FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_SUCCESS,
    FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_FAILURE,
    RESET_DEMAND_YARN_REQUIREMENT_INVOICE,
    FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_REQUEST,
    FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_SUCCESS,
    FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_FAILURE,
    RESET_DEMAND_FABRIC_REQUIREMENT_INVOICE,
    FETCH_DEMAND_FABRIC_COLOR_INVOICE_REQUEST,
    FETCH_DEMAND_FABRIC_COLOR_INVOICE_SUCCESS,
    FETCH_DEMAND_FABRIC_COLOR_INVOICE_FAILURE,
    RESET_DEMAND_FABRIC_COLOR_INVOICE,
    FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST,
    FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS,
    FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE,
    RESET_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE,
    FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_REQUEST,
    FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_SUCCESS,
    FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_FAILURE,
    RESET_DEMAND_PROGRAM_WISE_COST_INVOICE,
    FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_REQUEST,
    FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_SUCCESS,
    FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_FAILURE,
    RESET_DEMAND_COLOUR_WISE_SIZE_INVOICE,
    FETCH_ACCESSORIES_DEMAND_SUMMARY_REQUEST,
    FETCH_ACCESSORIES_DEMAND_SUMMARY_SUCCESS,
    FETCH_ACCESSORIES_DEMAND_SUMMARY_FAILURE,
    FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_REQUEST,
    FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_SUCCESS,
    FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_FAILURE,
    RESET_DEMAND_PROCESS_COST_PER_PCS_INVOICE,
    SET_DEMAND_PASSWORD_FOR_REPLACE,
    GET_FABRIC_REPLACE_TRIGGER_REQUEST,
    GET_FABRIC_REPLACE_TRIGGER_SUCCESS,
    GET_FABRIC_REPLACE_TRIGGER_FAILURE,
    CREATE_POST_DATA_GET,
    GET_LOADED_DIA_REQUEST,
    GET_LOADED_DIA_FAILURE,
    GET_LOADED_DIA_SUCCESS,
    POST_FABRIC_COMMON_REQUEST,
    POST_FABRIC_COMMON_SUCCESS,
    POST_FABRIC_COMMON_FAILURE,
    GET_LOADING_SALES_ORDER_SUCCESS,
    GET_DEMAND_CONTENT_SALES_ORDER_REQUEST,
    GET_DEMAND_CONTENT_SALES_ORDER_FAILURE,
    FAILURE_DEMAND_CHECKER,
    CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST,
    CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS,
    CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE,
    CREATE_FABRIC_COLOR_DEMAND_REPLACE_SUCCESS,
    CREATE_FABRIC_COLOR_DEMAND_REPLACE_REQUEST,
    CREATE_FABRIC_COLOR_DEMAND_REPLACE_FAILURE,
    CREATE_NEW_FABRIC_CHECK_REQUEST,
    CREATE_NEW_FABRIC_CHECK_FAILURE,
    CREATE_NEW_FABRIC_CHECK_SUCCESS,
    CREATE_NEW_FABRIC_COLOR_DEMAND_REQUEST,
    CREATE_NEW_FABRIC_COLOR_DEMAND_SUCCESS,
    CREATE_NEW_FABRIC_COLOR_DEMAND_FAILURE,
    CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_USERFORM_RESET,
    CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST,
    CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS,
    CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE,
    CREATE_ACCESSORIES_DEMAND_REPLACE_REQUEST,
    CREATE_ACCESSORIES_DEMAND_REPLACE_SUCCESS,
    CREATE_ACCESSORIES_DEMAND_REPLACE_FAILURE,
    CREATE_NEW_ACCESSORIES_DEMAND_REQUEST,
    CREATE_NEW_ACCESSORIES_DEMAND_SUCCESS,
    CREATE_NEW_ACCESSORIES_DEMAND_FAILURE,
    UPDATE_DEMAND_REVERT_STATUS_REQUEST,
    UPDATE_DEMAND_REVERT_STATUS_FAILURE,
    UPDATE_DEMAND_REVERT_STATUS_SUCCESS,
    UPDATE_PATTERN__REQUEST,
    UPDATE_PATTERN__FAILURE,
    UPDATE_PATTERN__SUCCESS,
    UPDATE_REMARKS_SUCCESS,
    RESET_ALL_INVOICE,
    FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_SUCCESS,
    FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_FAILURE,
    FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_REQUEST,
} from './salesOrderDemand.actionsType';

export const SALES_ORDER_DEMAND = 'salesOrderDemand';

let initialState = {
    loading: false,
    salesOrderDemand: [],
    accessoriesDemand: [],
    accessoriesDemandSummary: [],
    salesOrderDemandFabric: [],
    salesOrderDemandFabricColor: [],
    errorMessage: '',
    iperrorMessage: '',
    demandPassword: '',
    demandInvoice: [],
    demandYarnReqInvoice: [],
    demandFabReqInvoice: [],
    demandFabColorReqInvoice: [],
    demandPWCInvoice: [],
    demandAccessReqInvoice: [],
    demandColorSizeReqInvoice: [],
    demandprocesscostperpcsInvoice: [],
    fldRequirementData: '',
    userfabricData: {},
    getDiaData: [],
    fabriccolorAdditionRequirement: {},
    fabriccolorReplace: {},
    newFabricId: '',
    newFabricDemand: {},
    accessoriesAddRequirement: {},
    accessoriesReplace: {},
    resultCheckingExecuteApi: false,
    newaccessoriesdemand: {},
    pattern: null,
    reqReportByStyle: []
};

export let salesOrderDemandReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_SALES_ORDER_DEMAND_REQUEST:
        case FETCH_SALES_ORDER_DEMAND_FABRIC_REQUEST:
        case FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_REQUEST:
        case FETCH_DEMAND_INVOICE_REQUEST:
        case FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_REQUEST:
        case FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_REQUEST:
        case FETCH_DEMAND_FABRIC_COLOR_INVOICE_REQUEST:
        case FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST:
        case FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_REQUEST:
        case FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_REQUEST:
        case FETCH_ACCESSORIES_DEMAND_REQUEST:
        case FETCH_ACCESSORIES_DEMAND_SUMMARY_REQUEST:
        case FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_REQUEST:
        case GET_FABRIC_REPLACE_TRIGGER_REQUEST:
        case GET_LOADED_DIA_REQUEST:
        case POST_FABRIC_COMMON_REQUEST:
        case CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST:
        case CREATE_FABRIC_COLOR_DEMAND_REPLACE_REQUEST:
        case CREATE_NEW_FABRIC_CHECK_REQUEST:
        case CREATE_NEW_FABRIC_COLOR_DEMAND_REQUEST:
        case CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_REQUEST:
        case CREATE_ACCESSORIES_DEMAND_REPLACE_REQUEST:
        case CREATE_NEW_ACCESSORIES_DEMAND_REQUEST:
        case UPDATE_DEMAND_REVERT_STATUS_REQUEST:
        case UPDATE_PATTERN__REQUEST:
        case FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_REQUEST:
            // case GET_DEMAND_CONTENT_SALES_ORDER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SALES_ORDER_DEMAND_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderDemand: updatePayload
            };
        case FETCH_SALES_ORDER_DEMAND_FABRIC_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderDemandFabric: updatePayload
            };
        case FETCH_ACCESSORIES_DEMAND_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDemand: updatePayload
            };
        case GET_LOADING_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                loadForCont: updatePayload
            }
        case FETCH_ACCESSORIES_DEMAND_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDemandSummary: updatePayload
            };
        case FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderDemandFabricColor: updatePayload
            };
        case FAILURE_DEMAND_CHECKER:
            return {
                ...state,
                loading: false,
                resultCheckingExecuteApi: updatePayload
            }
        case RESET_ALL_INVOICE:
            return {
                ...state,
                loading: false,
                demandInvoice: [],
                demandYarnReqInvoice: [],
                demandFabReqInvoice: [],
                demandFabColorReqInvoice: [],
                demandAccessReqInvoice: [],
                demandPWCInvoice: [],
                demandColorSizeReqInvoice: []
            }

        case FETCH_DEMAND_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandInvoice: updatePayload
            };

        case RESET_DEMAND_INVOICE:
            return {
                ...state,
                demandInvoice: []
            };
        case SET_DEMAND_PASSWORD_FOR_REPLACE:
            return {
                ...state,
                loading: false,
                demandPassword: payload
            };
        case CREATE_POST_DATA_GET:
            return {
                ...state,
                loading: false,
                userfabricData: {
                    ...state.userfabricData,
                    [payload.key]: payload.value
                }
            };
        case CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                fabriccolorAdditionRequirement: updatePayload
            };

        case CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesAddRequirement: updatePayload
            };
        case CREATE_FABRIC_COLOR_DEMAND_REPLACE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabriccolorReplace: updatePayload
            };
        case CREATE_ACCESSORIES_DEMAND_REPLACE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesReplace: updatePayload
            };
        case CREATE_NEW_ACCESSORIES_DEMAND_SUCCESS:
            return {
                ...state,
                loading: false,
                newaccessoriesdemand: updatePayload
            };
        case CREATE_NEW_FABRIC_CHECK_SUCCESS:
            return {
                ...state,
                loading: false,
                newFabricId: updatePayload
            };
        case CREATE_NEW_FABRIC_COLOR_DEMAND_SUCCESS:
            return {
                ...state,
                loading: false,
                newFabricDemand: updatePayload
            };
        case FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandYarnReqInvoice: updatePayload
            };
        case RESET_DEMAND_YARN_REQUIREMENT_INVOICE:
            return {
                ...state,
                demandYarnReqInvoice: []
            };

        case FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandFabReqInvoice: updatePayload
            };
        case RESET_DEMAND_FABRIC_REQUIREMENT_INVOICE:
            return {
                ...state,
                demandFabReqInvoice: []
            };

        case FETCH_DEMAND_FABRIC_COLOR_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandFabColorReqInvoice: updatePayload
            };
        case RESET_DEMAND_FABRIC_COLOR_INVOICE:
            return {
                ...state,
                demandFabColorReqInvoice: []
            };
        case FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandAccessReqInvoice: updatePayload
            };
        case RESET_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE:
            return {
                ...state,
                demandAccessReqInvoice: []
            };
        case FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandPWCInvoice: updatePayload
            };
        case RESET_DEMAND_PROGRAM_WISE_COST_INVOICE:
            return {
                ...state,
                demandPWCInvoice: []
            };
        case FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandColorSizeReqInvoice: updatePayload
            };
        case RESET_DEMAND_COLOUR_WISE_SIZE_INVOICE:
            return {
                ...state,
                demandColorSizeReqInvoice: []
            };
        case FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                demandprocesscostperpcsInvoice: updatePayload
            };
        case RESET_DEMAND_PROCESS_COST_PER_PCS_INVOICE:
            return {
                ...state,
                demandprocesscostperpcsInvoice: []
            };
        case GET_FABRIC_REPLACE_TRIGGER_SUCCESS: {
            return {
                ...state,
                fldRequirementData: updatePayload
            };
        }
        case GET_LOADED_DIA_SUCCESS: {
            return {
                ...state,
                getDiaData: updatePayload
            };
        }
        case UPDATE_DEMAND_REVERT_STATUS_SUCCESS: {
            return {
                ...state,
                demandStatus: updatePayload
            };
        }
        case UPDATE_PATTERN__SUCCESS: {
            return {
                ...state,
                pattern: action.payload,
            };
        }

        case UPDATE_REMARKS_SUCCESS: {
            return {
                ...state,
                remarks: action.payload,
            };
        }

        case FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_SUCCESS: {
            return {
                ...state,
                reqReportByStyle: updatePayload,
            };
        }
        case FETCH_SALES_ORDER_DEMAND_FAILURE:
        case FETCH_SALES_ORDER_DEMAND_FABRIC_FAILURE:
        case FETCH_SALES_ORDER_DEMAND_FABRIC_COLOR_FAILURE:
        case FETCH_DEMAND_INVOICE_FAILURE:
        case FETCH_DEMAND_YARN_REQUIREMENT_INVOICE_FAILURE:
        case FETCH_DEMAND_FABRIC_REQUIREMENT_INVOICE_FAILURE:
        case FETCH_DEMAND_FABRIC_COLOR_INVOICE_FAILURE:
        case FETCH_DEMAND_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE:
        case FETCH_DEMAND_PROGRAM_WISE_COST_INVOICE_FAILURE:
        case FETCH_DEMAND_COLOUR_WISE_SIZE_INVOICE_FAILURE:
        case FETCH_ACCESSORIES_DEMAND_FAILURE:
        case FETCH_ACCESSORIES_DEMAND_SUMMARY_FAILURE:
        case FETCH_DEMAND_PROCESS_COST_PER_PCS_INVOICE_FAILURE:
        case GET_FABRIC_REPLACE_TRIGGER_FAILURE:
        case GET_LOADED_DIA_FAILURE:
        case POST_FABRIC_COMMON_FAILURE:
        case CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE:
        case CREATE_FABRIC_COLOR_DEMAND_REPLACE_FAILURE:
        case CREATE_NEW_FABRIC_CHECK_FAILURE:
        case CREATE_NEW_FABRIC_COLOR_DEMAND_FAILURE:
        case CREATE_ACCESSORIES_DEMAND_ADDITIONAL_REQUIREMENT_FAILURE:
        case CREATE_ACCESSORIES_DEMAND_REPLACE_FAILURE:
        case CREATE_NEW_ACCESSORIES_DEMAND_FAILURE:
        case UPDATE_DEMAND_REVERT_STATUS_FAILURE:
        case UPDATE_PATTERN__FAILURE:
        case FETCH_SALES_ORDER_REQ_REPORT_BY_STYLE_FAILURE:
            // case GET_DEMAND_CONTENT_SALES_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_FABRIC_COLOR_DEMAND_ADDITIONAL_REQUIREMENT_USERFORM_RESET:
            return {
                ...state,
                loading: false,
                userfabricData: {
                    fldRemarks: state?.userfabricData?.fldRemarks
                }
            };
        default:
            return state;
    }
};
